import AdminBooking from "../../Pages/adminBooking/Booking/AdminBooking";
import AdminSeatLock from "../../Pages/adminBooking/Locking/AdminSeatLock";
import Bus from "../../Pages/Bus/Bus";
import Home from "../../Pages/Home/Home";
import Info from "../../Pages/Info/Info";
import ManageBooking from "../../Pages/Manage/Booking/ManageBooking";
import CancelBooking from "../../Pages/Manage/CancelBooking/CancelBooking";
import Contact from "../../Pages/Manage/Contact/Contact";
import DateWiseBooking from "../../Pages/Manage/dateWiseBooking/DateWiseBooking";
import InfoManage from "../../Pages/Manage/InfoManage/InfoManage";
import OfferManage from "../../Pages/Manage/Offer/OfferManage";
import ManagePackage from "../../Pages/Manage/Package/ManagePackage";
import UserContact from "../../Pages/Manage/UserContact/UserContact";
import Offer from "../../Pages/offer/Offer";
import Vacation from "../../Pages/Package/Package";
import PdfGenerate from "../../Pages/pdfgenerate/PdfGenerate";
import OfflinePayment from "../../Pages/report/OfflinePayment";
import SeatLockReport from "../../Pages/report/SeatLockReport";
import Unlock from "../../Pages/adminBooking/Unlock/Unlock"
import NotFound from "../NotFound/NotFound";

const route = [
  { path: "/", element: <Home /> },
  { path: "/manage/contact", element: <Contact /> },
  { path: "/manage/contact", element: <Contact /> },
  { path: "/manage/package", element: <ManagePackage /> },
  { path: "/manage/booking", element: <ManageBooking /> },
  { path: "/manage/cancel-booking", element: <CancelBooking /> },
  { path: "/manage/date-wise-booking", element: <DateWiseBooking /> },
  { path: "/manage/user-contact", element: <UserContact /> },
  { path: "/manage/offer", element: <OfferManage /> },
  { path: "/manage/info", element: <InfoManage /> },
  { path: "/package", element: <Vacation /> },
  { path: "/info", element: <Info /> },
  { path: "/offer", element: <Offer /> },
  { path: "/bus-layout", element: <Bus /> },
  { path: "/admin-booking", element: <AdminBooking /> },
  { path: "/admin-seatlock", element: <AdminSeatLock /> },
  { path: "/admin-seat-unlock", element: <Unlock/> },
  { path: "/manage/pdfGenerate", element: <PdfGenerate /> },
  {path:"/offline-payment-report", element:<OfflinePayment/>},
  {path:"/admin-seatlock-report",element:<SeatLockReport/>},
  { path: "*", element: <NotFound /> },
];

export default route;
